import { Extension } from "@tiptap/core";

/**
 * Vervangt RtfEditorTabCharExtension uit de toolkit: die voegt altijd een tab-teken toe,
 * ook in lijsten waar Tab een niveau dieper hoort te gaan.
 */
export const ListTabExtension = Extension.create({
  name: "listTabExtension",
  addKeyboardShortcuts() {
    return {
      Tab: ({ editor }) => {
        // Codeblokken regelen hun eigen inspringing (enableTabIndentation).
        if (editor.isActive("codeBlock")) return false;
        if (editor.isActive("listItem")) {
          // Binnen een lijst nooit een tab-teken invoegen, ook niet bij het eerste item.
          editor.commands.sinkListItem("listItem");
          return true;
        }
        return editor.commands.insertContent("\t");
      },
      "Shift-Tab": ({ editor }) => {
        if (editor.isActive("codeBlock")) return false;
        if (editor.isActive("listItem")) {
          editor.commands.liftListItem("listItem");
          return true;
        }
        return false;
      },
    };
  },
});
